import { useState } from 'react';

import { AlertDialog, Button, createMqStyles, useMqSelect } from '@fhs/ui';

import { useMenuPicker } from '../../state/menu-picker';

type ConfirmUnsavedCustomizationModalParams = {
  onOpen?: () => void;
  onClose?: () => void;
};

export const useConfirmUnsavedCustomizationModal = ({
  onOpen,
  onClose,
}: ConfirmUnsavedCustomizationModalParams = {}) => {
  const {
    setUserCustomizationSelections,
    setDraftCustomizationSelections,
    draftCustomizationSelections,
  } = useMenuPicker();

  const [isOpen, setIsOpen] = useState(false);
  const isDesktop = useMqSelect({ $gteDesktop: true }, false);
  const saveChangesButtonText = isDesktop ? 'Save Changes' : 'Save Customizations';
  const mqStyles = useMqStyles();
  const confirmationDialog = (
    <AlertDialog
      visible={isOpen}
      accessibilityLabel="You Have Unsaved Customizations"
      headingContent="You Have Unsaved Customizations"
      bodyContent="Are you sure you want to leave without saving your customizations?"
      onRequestClose={() => setIsOpen(false)}
      onDismiss={() => setIsOpen(false)}
      onClose={() => setIsOpen(false)}
      actions={
        <>
          <Button
            size="xl"
            type="solid"
            style={mqStyles.actions}
            onPress={() => {
              setUserCustomizationSelections(draftCustomizationSelections);
              onClose?.();
              setIsOpen(false);
            }}
          >
            <Button.Text>{saveChangesButtonText}</Button.Text>
          </Button>
          <Button
            size="xl"
            type="outline"
            style={mqStyles.actions}
            onPress={() => {
              setDraftCustomizationSelections({});
              onClose?.();
              setIsOpen(false);
            }}
          >
            <Button.Text>Don't Save</Button.Text>
          </Button>
        </>
      }
    />
  );

  const openConfirmationDialog = () => {
    onOpen?.();
    setIsOpen(true);
  };

  return {
    confirmationDialog,
    openConfirmationDialog,
  };
};

const useMqStyles = createMqStyles({
  actions: {
    $gteDesktop: {
      flex: 1,
    },
  },
});
